import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import type { BriefingStep } from './types'

export type ComponentRohsBriefingStepKey =
  | 'waiting'
  | 'testReport'
  | 'drawings'
  | 'signOff'

export type ComponentRohsBriefingStep = BriefingStep & {
  key: ComponentRohsBriefingStepKey
}

function slotFileName(
  file: RohsComponentComplianceFileDetailView | null | undefined,
  slotKind: 'TEST_REPORT' | 'DRAWINGS_SCHEMAS'
): string | null {
  const slot = file?.slots.find((item) => item.slotKind === slotKind)
  return slot?.fileName ?? null
}

export function buildComponentRohsBriefing(input: {
  canFulfil: boolean
  file: RohsComponentComplianceFileDetailView | null | undefined
}): {
  steps: Omit<
    ComponentRohsBriefingStep,
    'title' | 'description' | 'requirednessLabel'
  >[]
} {
  if (!input.canFulfil) {
    return {
      steps: [
        {
          key: 'waiting',
          status: 'guidance',
          requiredness: 'informational',
        },
      ],
    }
  }

  const testReportFileName = slotFileName(input.file, 'TEST_REPORT')
  const drawingsFileName = slotFileName(input.file, 'DRAWINGS_SCHEMAS')
  const isSignedOff = input.file?.completedAt != null

  return {
    steps: [
      {
        key: 'testReport',
        status: testReportFileName != null ? 'done' : 'open',
        requiredness: 'required',
      },
      {
        key: 'drawings',
        status: drawingsFileName != null ? 'done' : 'open',
        requiredness: 'optional',
      },
      {
        key: 'signOff',
        status: isSignedOff ? 'done' : 'open',
        requiredness: 'required',
      },
    ],
  }
}
